export default {"src":"/_next/static/media/main_logo.38aeb1d1.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};